import React from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import "./DesarrolloWeb.css";

function Optimizacion() {
  return (
    <>
      <SEO
        title="Optimización Web | Velocidad y SEO Técnico"
        description="Mejora la velocidad, rendimiento y SEO técnico de tu sitio web."
        url="https://juancarlosmancharamos.ar/optimizacion-web"
      />

      <Menu />

      <HeroInner
        title="Optimización Web"
        subtitle="Velocidad, SEO técnico y rendimiento"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <h2>Mejorá el rendimiento de tu sitio</h2>

        <p>
          Optimización avanzada de velocidad, Core Web Vitals y estructura SEO
          técnica.
        </p>

        <p>
          Auditorías completas para detectar problemas y mejorar el rendimiento.
        </p>

        <h3>Resultados</h3>

        <p>
          Sitios más rápidos, mejor posicionamiento y mayor conversión.
        </p>
      </section>

      <section id="abt-lnk" className="center-first">
        <div className="container text-center">
          <h2>+ servicios</h2>
          <Services />
        </div>
      </section>

      <ChatBot />
      <GlobalScripts />
    </>
  );
}

export default Optimizacion;